export default __webpack_public_path__ + "static/media/no_tf.6d73ccdf.png";